module.exports = __webpack_public_path__ + "static/media/PR_01_B.4618b964.png";